// -----------------------------------------------------------------------------
// <copyright file="chunk-handler.service.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { ErrorHandler, Injectable } from '@angular/core';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error(error);
    const chunkFailedMessage = /Failed to fetch dynamically imported module/;
    if (chunkFailedMessage.test(error.message)) {
      const count = JSON.parse(localStorage.getItem('reloadCount') || '0');
      if (count < 4) {
        localStorage.setItem('reloadCount', JSON.stringify(count + 1));
        window.location.reload();
      }
    }
  }
}
